import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import { Button } from 'app/src/elements/buttons';
import { Text } from 'app/src/styles';

const OptionLabel = styled(Text)`
  color: ${props => props.selected ? '#000000' : '#808080'};
`;

const Option = ({ option, selected, toggleSelected }) => {
  return (
    <Pressable onPress={() => toggleSelected(option)}>
      <OptionLabel selected={selected}>{option.name}</OptionLabel>
    </Pressable>
  );
};

const Filter = ({ label, filterKey, options, updateFilters }) => {
  const [show, setShow] = useState(false);
  const [selected, setSelected] = useState([]);

  const toggleSelected = option => {
    if (selected.includes(option.id)) {
      setSelected(selected.filter(id => id !== option.id));
    } else {
      setSelected([...selected, option.id]);
    }
  };

  const handleApply = () => {
    updateFilters(filterKey, selected);
    setShow(false);
  };

  if (selected.length > 0) {
    label = label + ': ' + options
      .filter(({ id }) => selected.includes(id))
      .map(({ name }) => name)
      .join(', ');
  }

  if (show) {
    return (
      <View>
        {(options || []).map(option => (
          <Option
            key={option.id}
            option={option}
            selected={selected.includes(option.id)}
            toggleSelected={toggleSelected}
          />
        ))}

        <Button label="Apply" onPress={handleApply} wide />
      </View>
    );
  } else {
    return (
      <Button label={label} onPress={() => setShow(true)} wide />
    );
  }
};

export default Filter;
